<template>
  <div class="mb-4 border-b border-gray-200">
    <ul class="-mb-px flex flex-wrap text-center text-sm font-medium">
      <slot></slot>
    </ul>
  </div>
</template>
